import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addAccessorial, AddAccessorialApiParameters } from "@tKgpco/Services/AccessorialsService";
import { CreditAnalystParameters, sendContactCreditAnalyst } from "@tKgpco/Services/CustomerFormsService";
import { updateDiscrepancy, UpdateDiscrepancyApiParameter } from "@tKgpco/Services/DiscrepancyService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = CreditAnalystParameters & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, any>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
    };
};

export const SendCreditAnalyst: HandlerType = async props => {
    try {
        await sendContactCreditAnalyst(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, SendCreditAnalyst, ExecuteOnSuccess];

const sendCreditAnalystHandler = createHandlerChainRunner(chain, "SendCreditAnalyst");
export default sendCreditAnalystHandler;
